export const configQuery = 'settingByDeployedProductId';
export const unitTestNodeInConfig = 'Unittest';

export const translationQuery = 'translationsByLanguageTag';
export const unitTestNodeInTranslation = 'unittest';

export const operationQuery = 'operationSummariesByTimeRange';
export const operationSchema = `
{
  items{
    id
    startTime
    endTime
    acid
    airline
    runwayName
    airportId
    remoteAirportId
    operationType
    aircraftCategory
    time
    profile {
      alt: altitude
      dist: distance
      time: timeOffset
    }
    points
    {
      t
      lat
      lon
      alt
    }
  }
}
`;

export const infringementRulesQuery = 'infringementRules';
export const infringementRulesSchema = `
  {
    id
    isActive
    infringementType
    description
    name
    lastUpdateTime
    candidateFilter {
      aircraftCategories
      aircraftTypes
      airportRunways {
        airportId
        runwayNames
      }
      daysOfWeek
      endTime
      lowestMaxTakeOffWeight
      lowestMaxLandingWeight
      operationTypes
      operatorCategories
      pathName
      queryString
      startTime
    }
    ... on CcoInfringementRule {
      id
      maxAltitudeVariation
      autoInfringementSegmentLength
      ceilingAltitude
      floorAltitude
      maxLevelSegments
      minLevelSegmentLength
      maxAltitudeVariation
    }
    ... on CdoInfringementRule {
      id
      maxAltitudeVariation
      autoInfringementSegmentLength
      ceilingAltitude
      floorAltitude
      maxLevelSegments
      minLevelSegmentLength
      maxAltitudeVariation
    }
    ... on CorridorInfringementRule {
      id
      name
      allowedPassage
      ceilingAltitude
      corridorId
    }
    ... on GateInfringementRule {
      gateCriteria {
        altitudeRange {
          start
          end
        }
        gateDirections
        gateId
        intersectionMode
        speedRange {
          start
          end
        }
      }
    }
    ... on CurfewInfringementRule {
      candidateFilter {
        startTime
        endTime
      }
    }
    ... on ExclusionInfringementRule {
      selectionZoneId
    }
    ... on MinHeightInfringementRule {
      id
      requiredAltitude
      flightDistance
    }
    ... on NoiseInfringementRule {
      metric
      thresholds {
        locationId
        threshold
      }
    }
  }
`;

export const gisQuery = 'gisLayers';
export const gisSchema = `
{
  id
  name
  format
  minZoomLevel
  maxZoomLevel
  visible
  ... on VectorLayerType {
    fillColor {
      name
      red
      green
      blue
      alpha
      hex
    }
    lineColor {
      name
      red
      green
      blue
      alpha
      hex
    }
    lineWidth
  }
}
`;

export const scenarioQuery = 'scenario';
export const scenariosQuery = 'scenarios';
export const scenariosSchema = `
{
  id
  name
  isActive
  isDefault
  isLocked
  startTime
  endTime
  airportId
  defaultOptimumTMAApproachDistance
  applyWeatherAdjustment
  defaultLoadFactor
  defaultDurationClimb
  defaultDurationTaxiIn
  defaultDurationTakeOff
  defaultDurationTaxiOut
  defaultDurationApproach
  emissionRateMode
  emissionRateAvGas
  emissionRateSingle
  emissionRateJetFuel
  emissionRateUnknown

}`;

export const searchAddressQuery = 'searchAddress';
export const searchAddressSchema = `
query SearchAddress($address: String!, $bounds: InputGeographicCircleType) {
  searchAddress(address: $address, bounds: $bounds) {
    id
    formattedAddress
  }
}
`;

export const geocodeCandidateDetailQuery = 'geocodeCandidateDetail';
export const geocodeCandidateDetailSchema = `
query geocodeCandidateDetail($id: String!) {
  geocodeCandidateDetail(id: $id) {
    city
    country
    county
    formattedAddress
    neighborhood
    postcode
    state
    streetAddress
    streetName
    streetNumber
    position {
      latitude
      longitude
      altitude
    }
  }
}
`;

export const geocodePositionQuery = 'geocodePosition';
export const geocodePositionSchema = `
query geocodePosition($position: InputPositionType!) {
  geocodePosition(position: $position) {
    formattedAddress
    position {
      altitude
    }
  }
}
`;
